import React, { useEffect, useState } from 'react';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { CheckboxSwitch } from '@prisjakt/ui/checkbox/variants';
import { IFilterOptionProps } from './types';
import { FilterOptionWrapper, CheckboxClickarea } from '../styles';

const FilterOption = (props: IFilterOptionProps) => {
  const { name, defaultValue, onFilterChangedHandler, label, caption } = props;
  const [isChecked, setIsChecked] = useState(defaultValue);

  useEffect(() => {
    if (defaultValue !== isChecked) {
      setIsChecked(defaultValue);
    }
  }, [defaultValue]);

  const onChangeHandler = (e?: React.ChangeEvent<HTMLInputElement>) => {
    e?.preventDefault();
    const newVal = !isChecked;
    setIsChecked(newVal);
    onFilterChangedHandler(props.filterType);
  };

  return (
    <FilterOptionWrapper>
      <CheckboxClickarea>
        <CheckboxSwitch
          id={name}
          text={label}
          onChange={() => onChangeHandler()}
          checked={isChecked}
        />
        {caption && <CaptionText container="div">{caption}</CaptionText>}
      </CheckboxClickarea>
    </FilterOptionWrapper>
  );
};

export default FilterOption;
